import { Permission } from "api";
import { useMemo } from "react";

export type PermissionType =
    // campaign view permissions
    | "DOWNLOAD"
    | "DELIVER"
    | "UPLOAD_ADMATERIAL"
    | "UPLOAD"
    | "UPLOAD_ASSET"
    | "REVIEW_ASSET"
    // annotations permissions
    | "SAVEOTHER"
    | "SAVEOWN"
    | "REVIEW"
    | "DELETE"
    | "CREATE"
    // annotations action permissions
    | "APPROVE"
    | "APPROVEWITHCHANGES"
    | "SUBMIT"
    | "SUBMITONLY"
    // tabs permissions
    | "ANNOTATIONS"
    | "ASSETS"
    | "FILES"
    | "HISTORY"
    | "INFO"
    | "NOTES"
    | "REPORT"
    // assets/visuals permissins
    | "SENDTOPRODUCTION";
interface PermissionProps {
    disabled: boolean;
    display: boolean;
    tooltip: string;
}

type Permissions = {
    [key in PermissionType]?: PermissionProps;
};

export const usePermissions = (permissions: Permission[] = []) => {
    const checkPermissions = (permissions: Permission[]) => {
        return permissions.reduce<Permissions>((reasons, permission) => {
            return {
                ...reasons,
                [permission.name]: {
                    display: permission && permission.enabled ? permission.enabled : permission?.display,
                    disabled: permission?.display,
                    tooltip: permission?.reason || "",
                },
            };
        }, {} as Permissions);
    };

    return useMemo(() => checkPermissions(permissions), [permissions]);
};
